<template>
  <div class="is-flex is-align-items-center">
    <select class="select" @change="onChange">
      <option :selected="selectedReason === ''" :value="''">Select cancellation reason</option>
      <option
        v-for="reason in reasons"
        :key="reason"
        :value="reason"
        :selected="reason === selectedReason"
      >
        {{ reason }}
      </option>
    </select>
    <span class="tag" style="font-size: 0.6rem">{{ this.actionList.length }}</span>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import type MasterItem from '@/logic/TasksScreen/MasterItem'
import { TasksScreenManager } from '@/logic/TasksScreen'
import type { Action, TaskTypeKey } from '@/interfaces'
import { SALES_CANCELLATION_REASONS } from '@/logic/TasksScreen/cancellationReasons'

interface StoredAction {
  item: MasterItem
  callback: Function
  action: Action
  taskType: TaskTypeKey
}

@Component({})
export default class CancelReasonSelectBulk extends Vue {
  @Prop({}) actionList!: Array<StoredAction>
  @Prop({}) manager!: TasksScreenManager

  protected selectedReason: string = ''

  get reasons(): string[] {
    return SALES_CANCELLATION_REASONS
  }

  protected onChange(event: InputEvent) {
    const target = event.target as HTMLSelectElement
    this.selectedReason = target.value

    this.updateBulkReason(this.selectedReason)
  }

  protected updateBulkReason(reason: string) {
    this.manager.setActionDataForItems({ cancellationReason: reason }, this.actionList)
  }

  mounted() {
    this.updateBulkReason(this.selectedReason)
  }
}
</script>

<style lang="scss" scoped>
.select {
  margin-right: 5px;
  font-size: 10px;
  height: 14px !important;
}
</style>
